module.exports = __webpack_public_path__ + "img/resume-pool.4292b88e.svg";